import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Button as MuiButton } from '@mui/material';

import s from './styled';

const Button = React.forwardRef((props, ref) => {
  const { children, loading, className, inactive, ...rest } = props;

  return (
    <s.Button
      ref={ref}
      className={clsx(className, {
        'Button-loading': loading,
        'Button-inactive': inactive,
      })}
      $inactive={inactive || loading}
      {...rest}
    >
      {loading ? (
        <>
          <s.CircularProgress size="1em" />
          <s.Hidden>{children}</s.Hidden>
        </>
      ) : (
        children
      )}
    </s.Button>
  );
});

Button.propTypes = {
  ...MuiButton.propTypes,
  loading: PropTypes.bool,
  inactive: PropTypes.bool,
};

export default Button;
